document.addEventListener('DOMContentLoaded', function() {
  hoverSwatchers();
  
  window.addEventListener("klaviyoForms", function(e) {
    const { type, formId } = e.detail;

    const targetFormIds = ["WjbUT8", "XLvwXF", "Vp5AZ6"];
    if (type === "embedOpen" && targetFormIds.includes(formId)) {
      onKlaviyoFormOpen(formId);
    }
  });
});

function updateCityDisplayKlaviyo(contentForm, countryValue) {

  let optionsCountry = contentForm.querySelectorAll('#downshift-0-menu div[role="option"]');
  let inputB2BPais = contentForm.querySelector(`input[id^="B2B_Pais_"]`);
  const restWorldLabels = ['Resto del Mundo', 'Rest of the World', 'Resto del mondo'];

  if(!optionsCountry.length || !countryValue) {
    inputB2BPais.setAttribute('data-display', 'none');
  }

  if (restWorldLabels.includes(countryValue)) {
    inputB2BPais.setAttribute('data-display', 'flex');
  } else {
    inputB2BPais.setAttribute('data-display', 'none');
  }

  optionsCountry.forEach((country) => {
    country.addEventListener('click', function() {
      let inputCountry = contentForm.querySelector('#downshift-0-input');
      if (!inputCountry) {
        return;
      }


      const isRestWorld = restWorldLabels.includes(inputCountry.value);

      inputB2BPais = contentForm.querySelector(`input[id^="B2B_Pais_"]`);
      if (!inputB2BPais) {
        return;
      }

      const container = inputB2BPais.closest('[data-testid="form-component"]');
      if (!container) {
        return;
      }

      if (isRestWorld) {
        inputB2BPais.setAttribute('data-display', 'flex');
      } else {
        inputB2BPais.setAttribute('data-display', 'none');
      }
    });
  });
}

function validCityOptions( contentForm, italian_cities, spain_cities ){
  let optionsCity = contentForm.querySelectorAll('#downshift-1-menu div[role="option"]');
  
  let inputCountry = contentForm.querySelector('#downshift-0-input');
  optionsCity.forEach((city) => {
    
    if( inputCountry.value === 'Italia' && italian_cities.includes(city.textContent) ){
      city.setAttribute('data-display', 'block');
    } 
    else if ( inputCountry.value === 'España' && spain_cities.includes(city.textContent) ) {
      city.setAttribute('data-display', 'block');
    }
    else {
      city.setAttribute('data-display', 'none');
    }
  });
};
function hoverSwatchers() {
  document.querySelectorAll(".group-colors").forEach((group) => {
    let colorLabel = group.querySelector(".color-label");
    let links = group.querySelectorAll(".link-color");
    
    if (!colorLabel || links.length === 0) return;
    
    let originalColor = colorLabel.getAttribute("original-data-color");
    
    links.forEach((link) => {
      link.addEventListener("mouseenter", () => {
        colorLabel.dataset.color = link.dataset.color;
      });
      
      link.addEventListener("mouseleave", () => {
        colorLabel.dataset.color = originalColor;
      });
    });
  });
}

function onKlaviyoFormOpen(formId) {
  const contentForm = document.querySelector(`.klaviyo-form-${formId}.klaviyo-form`);

  if( contentForm ){
    contentForm.setAttribute('style', 'display: block !important;');
    let inputB2BPais = contentForm.querySelector(`input[id^="B2B_Pais_"]`);
    if( inputB2BPais ){
      inputB2BPais.closest('[data-testid="form-component"]').setAttribute('data-display', 'none');
    }

    let menuCountry = contentForm.querySelector('#downshift-0-input');

    if (menuCountry) {
     addKlaviyoCityEvents(contentForm, menuCountry);
    } else {
      setTimeout(() => {
        const menuCountry = contentForm.querySelector('#downshift-0-input');
        if (menuCountry) {
          addKlaviyoCityEvents(contentForm, menuCountry);
        } else {
          window.location.reload();
        }
      }, 200);
    }
  }
}

function addKlaviyoCityEvents(contentForm, menuCountry) {
  updateCityDisplayKlaviyo(contentForm, menuCountry.value);
  menuCountry.addEventListener('click', function(event) {
    updateCityDisplayKlaviyo(contentForm, menuCountry.value);
  });
  menuCountry.addEventListener('change', function(event) {
    updateCityDisplayKlaviyo(contentForm, menuCountry.value);
  });
  menuCountry.addEventListener('input', function(event) {
    updateCityDisplayKlaviyo(contentForm, menuCountry.value);
  });

    const wrapper = contentForm.closest('.wim-klaviyo');
  if (wrapper) {
    setTimeout(() => { 
      wrapper.classList.add('show');
    }, 200);
  }
}
document.addEventListener('facet:update', function(event) {
  if (window.location.href.includes("filter.v.option.size") && !window.location.href.includes("filter.v.availability")) {
    window.location.href = `${window.location.href}&filter.v.availability=1`
  }
});